import React, { useState } from "react";

const StepProgressBar = ({stepLabels, currentStep , set}) => {
  



  const steps = stepLabels?.map((label, index) => ({
    label,
    completed: index < currentStep,
  }));

  const length = stepLabels?.length;

  const currentStepData = steps[currentStep - 1];

  return (
    <div className="w-full flex flex-col">
      <div className="w-full flex flex-col  justify-start items-start gap-2 w-full">
        <div className="flex items-center justify-start self-stretch [font-family:'Inter',Helvetica] font-normal text-transparent text-[12px] tracking-[0] leading-3">
          <span style={{ color: "#ffffffb2" }}>
            Step {currentStep} of {stepLabels.length}:
          </span>
          <span className="font-medium" style={{ color: "#ffffffb2" }}>
            &nbsp;
          </span>
          <span className="font-medium ml-1" style={{ color: "#ffffff" }}>
            {currentStepData?.label || ""}
          </span>
        </div>

        <div className="flex items-center justify-end gap-1 self-stretch w-full">
          {steps.map((step, index) => (
            <div
              key={index}
              className="flex-1 h-1.5 rounded-sm transition-colors duration-500 ease-in-out"
              style={{
                backgroundColor: step.completed ? "#406aff" : "#406aff4c",
              }}
            />
          ))}
        </div>
      </div>

      {/* <div className="flex gap-4">
        <button
          onClick={handlePrevious}
          disabled={currentStep === 1}
          className="px-4 py-2 bg-gray-700 text-white rounded disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-600 transition-colors"
        >
          Previous
        </button>
        <button
          onClick={handleNext}
          disabled={currentStep === stepLabels.length}
          className="px-4 py-2 bg-[#406aff] text-white rounded disabled:opacity-50 disabled:cursor-not-allowed hover:bg-[#3557e0] transition-colors"
        >
          Next
        </button>
      </div> */}
    </div>
  );
};

export default StepProgressBar;
